<template>
    <div class="panels-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Simple Panels</h3>
                </div>

                <ul class="panels-list">
                    <li class="panels-style-1">
                        Basic Panels Example
                    </li>
                </ul>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Panels Without Heading</h3>
                </div>

                <ul class="panels-list">
                    <li class="panels-style-1 bg-color-f9f9f9 border-bottom-0">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Panels Heading Background Color</h3>
                </div>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-primary rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-secondary rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-success rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-danger rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-warning rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-info rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-dark bg-light rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>

                <ul class="panels-list pb-24">
                    <li class="panels-style-1 text-white bg-dark rounded-top">
                        Panels Without Heading
                    </li>
                    <li class="panels-style-1 border-top-0 rounded-bottom">
                        Panels Content
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PanelsContent'
}
</script>

<style lang="scss">
.panels-list {
	padding-left: 0;
	margin-bottom: 0;
	list-style: none;
	.panels-style-1 {
		font-size: 15px;
		border: 1px solid #ddd;
		padding: 10px 20px;
		&.bg-color-f9f9f9 {
			background-color: #f9f9f9;
			border-color: #f9f9f9;
		}
	}
}
</style>